export default __webpack_public_path__ + "static/media/s4.4e62bda4.jpg";